import React, { PropsWithChildren } from 'react';
import Flex, { FlexProps } from '../Flex';

export type CenterProps = FlexProps;
const Center: React.FC<PropsWithChildren<CenterProps>> = ({
  align = 'center',
  justifyContent = 'center',
  children,
  ...rest
}) => {
  return <Flex {...rest}>{children}</Flex>;
};

export default Center;
